import {
  SET_ADS_LOADING,
  SET_ADS,
  DELETE_AD,
} from "../../constants/ActionTypes";
import { baseRequest } from "../../util/Api";
import {
  setErrorMessage,
  setLoadingMessage,
  setSuccessMessage,
} from "./Common";
import { v4 } from "uuid";

export const getAds = () => (dispatch) => {
  dispatch({
    type: SET_ADS_LOADING,
    payload: true,
  });
  baseRequest("get", "/ad-slot/")
    .then((data) => {
      dispatch({
        type: SET_ADS,
        payload: data,
      });
    })
    .catch((e) => {
      dispatch(setErrorMessage(e));
      dispatch({
        type: SET_ADS_LOADING,
        payload: false,
      });
    });
};

export const createAd = (data) => (dispatch) =>
  new Promise((resolve) => {
    const messageKey = v4();
    dispatch(setLoadingMessage("Membuat iklan ...", messageKey));
    baseRequest("post", "/ad-slot/", null, data)
      .then((newData) => {
        dispatch(setSuccessMessage("Berhasil membuat iklan", messageKey));
        resolve(newData);
      })
      .catch((e) => {
        dispatch(setErrorMessage(e, messageKey));
      });
  });

export const getAdImage = () => (dispatch) =>
  new Promise((resolve) => {
    baseRequest("get", "/ad-slot/ad-image-upload-url")
      .then((data) => {
        resolve(data);
      })
      .catch((e) => {
        dispatch(setErrorMessage(e));
      });
  });

export const deleteAd = (id) => (dispatch) =>
  new Promise((resolve, reject) => {
    const messageKey = v4();
    dispatch(setLoadingMessage("Menghapus iklan ...", messageKey));
    baseRequest("delete", "/ad-slot/" + id)
      .then(() => {
        dispatch(setSuccessMessage("Menghapus iklan berhasil", messageKey));
        dispatch({
          type: DELETE_AD,
          payload: id,
        });
        resolve();
      })
      .catch((e) => {
        dispatch(setErrorMessage(e, messageKey));
        reject();
      });
  });
